<template>
  <div class="shop-galery">
    <a class="lightbox" :title="title" @click="zoomEvent">
      <img
        :src="require(`@/assets/img/freefood/${image}`)"
        :alt="title"
        class="shop-galery__image"
      />
      <img
        :src="require(`@/assets/img/common/icon_expan.png`)"
        class="shop-galery__icon"
      />
    </a>
    <div class="caption">
      {{ title }}<span class="area">{{ area }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    title: String,
    area: String,
  },
  methods: {
    zoomEvent() {
      this.$store.dispatch("zoom/show", ["freefood", this.image]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/molecules/freeFood/shopGallery.scss";
</style>
